import {Component, effect, input, signal} from '@angular/core';

@Component({
  selector: 'cov-abstract-blending-page',
  imports: [],
  template: '<ng-content></ng-content>',
})
export abstract class AbstractBlendingPageComponent {
  private isActive = signal<boolean | undefined>(false);
  public active = input<boolean | undefined>(false);

  constructor() {
    effect(() => {
      const currActive = this.active();
      if (currActive !== this.isActive()) {
        this.isActive.set(currActive);
        if (currActive) {
          this.onActivated();
          return;
        }
        if (this.onDeactivated) {
          this.onDeactivated();
        }
      }
    });
  }

  public onActivated(): void {
    // can be overridden if needed
  }

  public onDeactivated?(): void {
    // can be overridden if needed
  }
}
